import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
`;

export const Chip = styled.div`
  margin-left: 6px;
  font-size: 12px;
  color: #535b6c;
  opacity: 1;
`;
